import React, { useState, useEffect, useCallback } from 'react';
import './ErrorModal.css';

const errorListeners = new Set();

export function showError(message, title = 'Error') {
  if (!message) return;
  const payload = { message: String(message), title };
  errorListeners.forEach((listener) => listener(payload));
}

export function ErrorModalHost() {
  const [error, setError] = useState(null);

  const close = useCallback(() => setError(null), []);

  useEffect(() => {
    const listener = (payload) => setError(payload);
    errorListeners.add(listener);
    return () => {
      errorListeners.delete(listener);
    };
  }, []);

  useEffect(() => {
    if (!error) return undefined;

    const handleKeyDown = (e) => {
      if (e.key === 'Escape' || e.key === 'Enter') {
        close();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.body.style.overflow = previousOverflow;
    };
  }, [error, close]);

  if (!error) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      close();
    }
  };

  return (
    <div className="modal-overlay error-modal-overlay" onClick={handleBackdropClick}>
      <div
        className="error-modal"
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="error-modal-title"
        aria-describedby="error-modal-message"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="error-modal-header">
          <h3 id="error-modal-title">{error.title}</h3>
          <button type="button" className="modal-close" onClick={close} aria-label="Close">
            ×
          </button>
        </div>
        <div className="error-modal-body">
          <p id="error-modal-message">{error.message}</p>
        </div>
        <div className="error-modal-actions">
          <button type="button" className="btn btn-primary" onClick={close} autoFocus>
            OK
          </button>
        </div>
      </div>
    </div>
  );
}

export default ErrorModalHost;
